import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const WettbewerberPreisViewDtoServiceConfig = {
  name: "WettbewerberPreisViewDto",
  annotations: []
} as ServiceConfig;